import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import moment from "moment";

function ListadoEmbarques() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_EMBARQUES = process.env.REACT_APP_URL_EMBARQUES;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_CONCEPTOS_GASTOS_EMBARQUES =
    process.env.REACT_APP_URL_CONCEPTOS_GASTOS_EMBARQUES;
  const URL_GASTOS_EMBARQUES = process.env.REACT_APP_URL_GASTOS_EMBARQUES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;

   let date = new Date();
    let hoy = moment(date).format("YYYY-MM-DD");

  const [embarques, setEmbarques] = useState([]);
  const [numeroEmbarque, setNumeroEmbarque] = useState([]);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState("");

  const [fechaEmbarque, setFechaEmbarque] = useState("");
  const [fechaEstimada, setFechaEstimada] = useState("");
  const [tipoCambioUSDMXN, setTipoCambioUSDMXN] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [contenedor, setContenedor] = useState("");
  const [numeroInterno, setNumeroInterno] = useState("");
  const [kasher, setKasher] = useState("");
  const [idEdit, setIdEdit] = useState("");
  const [idProveedor, setIdProveedor] = useState("");
  const [idProveedorEdit, setIdProveedorEdit] = useState("");
  const [idContenedor, setIdContenedor] = useState("");
  const [idNotaCxP, setIdNotaCxP] = useState("");

  const [articulosOC, setArticulosOC] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [proveedores, setProveedores] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);
  const [totalCaptura, setTotalCaptura] = useState(1000000);

  const [gastosEmbarque, setGastosEmbarque] = useState([]);
  const [modalEditGastos, setModalEditGastos] = useState(false);
  const toggleEditGastos = () => setModalEditGastos(!modalEditGastos);
  const [total_cantidadGastos, setTotalCantidadGastos] = useState(0);
  const [gastosEmbarquesTotales, setGastosEmbarquesTotales] = useState(0);
  const [conceptosGastos, setConceptosGastos] = useState([]);

    const [modalEditFOBKasher, setModalEditFOBKasher] = useState(false);
  const toggleEditFOBKasher = () => setModalEditFOBKasher(!modalEditFOBKasher);
  const [modalEditFOB, setModalEditFOB] = useState(false);
  const toggleEditFOB = () => setModalEditFOB(!modalEditFOB);
    const [articulosPedido, setArticulosPedido] = useState([]);
    const [tipoCambio, setTipoCambio] = useState(0);
    const [totalGastoPrecosteo, setTotalGastoPrecosteo] = useState(0);
    const [costeadoEdit, setCosteadoEdit] = useState(0);
    const [KT, setKT] = useState("");

  const [totalCantidad, setTotalCantidad] = useState(0);
  const [totalGeneral, setTotalGeneral] = useState(0);

  const [inputFieldsGastos, setInputFieldsGastos] = useState([
    {
      id: uuidv4(),
      concepto: "",
      estimado: 0,
      real: 0,
    },
  ]);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulosOrden: "",
      articulos: "",
      cantidad: 0,
      piezasPorCaja: 0,
      cajas: 0,
      cantidadOC: 0,
      costo: 0,
      costoTotal: 0,
      proveedorOrden: "",
    },
  ]);

    const [inputFieldsNuevos, setInputFieldsNuevos] = useState([
    {
      id: uuidv4(),
        articulosOrden: "",
        articulos: "",
        cantidad: 0,
        piezasPorCaja: 0,
        cajas: 0,
        cantidadOC: 0,
        costo: 0,
        costoTotal: 0,
        proveedorOrden: idProveedor,
        ordenCompra: "",
        CBM: 0,
        comisionVendedorPorcentaje: 0,
        comisionVendedorCantidad: 0,

    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [contenedorEdit, setContenedorEdit] = useState("");
  const [articulosOrden, setArticulosOrden] = useState([]);
  const [totalCantidadEdit, setTotalCantidadEdit] = useState("");
  const [totalGeneralEdit, setTotalGeneralEdit] = useState("");
  const [agrupado, setAgrupado] = useState([]);
  const [idArtEdit, setIdArtEdit] = useState("");
  const [recibidoEdit, setRecibidoEdit] = useState("");

  const [recibido, setRecibido] = useState("No");
  const [selectedCosteado, setSelectedCosteado] = useState("No");
  const [selectedKasher, setSelectedKasher] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(URL_EMBARQUES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmbarques = response.data;
        // Array para pagination
        let arrayTabla = allEmbarques
          .sort((a, b) => (a.idEmbarques > b.idEmbarques ? 1 : -1))
          .map((a) => {
            // if(a.total_cantidad > 0){
            return {
              is_active: a.is_active,
              recibido: a.recibido,
              _id: a._id,
              numero: a.idEmbarques,
              fechaEmbarque: a.fechaEmbarque,
              fechaEstimada: a.fechaEstimada,
              numeroInterno: a.numeroInterno,
              kasher: a.kasher,
              tipoCambioUSDMXN: a.tipoCambioUSDMXN,
              observaciones: a.observaciones,
              contenedor: a.contenedor,
              totalCantidad: parseFloat(a.total_cantidad).toFixed(2),
              total_gasto: parseFloat(a.total_gasto).toFixed(2),
              costeado: a.costeado,
              proveedor: a.proveedores[0].nombre_comercial,
              idProveedor: a.proveedores[0]._id,
              creado: a.creado[0].nombre + " " + a.creado[0].apellido,
              idCreado: a.creado[0]._id,
              total_costo: parseFloat(a.total_costo).toFixed(2),
              kasher: a.kasher,
              validado: a.validado,
              // proveedor: a.proveedores[0].nombre_comercial,
              // idProveedor: a.proveedores[0]._id,
            }
          // }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setEmbarques(allEmbarques);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
    axios
        .get(URL_ARTICULOS_OC, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        // Solo líneas de OC activas con pendiente por embarcar (fuente: ArticulosOC por OC)
        const allArticulosOC = res.data.filter(
          (a) =>
            a.is_active === "Si" &&
            a.pendiente_embarcar > 0 &&
            a.ordenesCompra?.[0]?.is_active === "Si"
        );
        setArticulosOC(allArticulosOC);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
    .get(`${URL_PROVEEDORES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CONCEPTOS_GASTOS_EMBARQUES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allConceptosGastos = res.data;
        setConceptosGastos(allConceptosGastos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const ListaEmbarques = comments.sort((a, b) =>
    a.idEmbarques > b.idEmbarques ? 1 : -1
  );

  function PDFTabla() {
    const data = ListaEmbarques.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (recibido == 0 || recibido == a.recibido)
      ) {
        return [
          a.recibido,
          a.numero,
          a.fechaEmbarque,
          a.contenedor,
          a.numeroInterno,
          a.fechaEstimada,
          a.observaciones,
          new Intl.NumberFormat("en-US").format(a.totalCantidad),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 30, 30);
    doc.text(`Listado de Embarques`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Recibido",
          "Numero",
          "Fecha Embarque",
          "Contenedor",
          "Numero Interno",
          "Fecha Estimada",
          "Observaciones",
          "Cantidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Embarques.pdf`);
  }

  function excel() {
    const dataExcel = ListaEmbarques.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (recibido == 0 || recibido == a.recibido)
      ) {
        return {
          Recibido: a.recibido,
          Numero: a.numero,
          FechaEmbarque: a.fechaEmbarque,
          Contenedor: a.contenedor,
          NumeroInterno: a.numeroInterno,
          FechaEstimada: a.fechaEstimada,
          Observaciones: a.observaciones,
          Cantidad: a.totalCantidad,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoEmbarques";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoEmbarques",
        sheetFilter: [
          "Recibido",
          "Numero",
          "FechaEmbarque",
          "Contenedor",
          "NumeroInterno",
          "FechaEstimada",
          "Observaciones",
          "Cantidad",
        ],
        sheetHeader: [
          "Recibido",
          "Numero",
          "FechaEmbarque",
          "Contenedor",
          "NumeroInterno",
          "FechaEstimada",
          "Observaciones",
          "Cantidad",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaEmbarques.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (recibido == 0 || recibido == a.recibido)
      ) {
        return [
          a.recibido,
          a.numero,
          a.fechaEmbarque,
          a.contenedor,
          a.numeroInterno,
          a.fechaEstimada,
          a.observaciones,
          new Intl.NumberFormat("en-US").format(a.totalCantidad),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 30, 30);
    doc.text(`Listado de Embarques`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Recibido",
          "Numero",
          "Fecha Embarque",
          "Contenedor",
          "Numero Interno",
          "Fecha Estimada",
          "Observaciones",
          "Cantidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Embarques",
          email: mailTo,
          fileName: "ListadoEmbarques.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Embarques.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }


async function PDFOCCostos(
  fechaEmbarque,
  contenedor,
  numeroInterno,
  fechaEstimada,
  creado,
  idPDFOC,
  numero
) {
  let totalCajas = 0;

  try {
    const response = await axios.get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idPDFOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    let allArticulosOrden = response.data || [];

    let arrayTabla = allArticulosOrden
      .map((a) => {
        const pzas = parseFloat(a?.articulos?.[0]?.piezasPorCaja || 0);
        const cant = parseFloat(a?.cantidad || 0);

        return {
          id: a._id,
          proveedor: a?.proveedores?.[0]?.nombre_comercial || "",
          articulo: a?.articulos?.[0]?.SKU || "",
          nombreArticulo: a?.articulos?.[0]?.nombre || "",
          pzasXcaja: pzas,
          cantidad: cant,
          cajas: pzas > 0 ? cant / pzas : 0,
          FOB: a?.costoUSD || 0,
          total_costo: a?.total_costo || 0,

          // ✅ para imagen (igual que en PDFOC)
          idArticulo: a?.articulos?.[0]?._id,
          fotoArticulo: a?.articulos?.[0]?.foto, // normalmente "Si"/"No"
          foto: "",
        };
      })
      .filter((el) => el != null);

    let dataFinal = Object.values(arrayTabla);

    // Totales
    let cantArr = dataFinal.map((c) => parseFloat(c.cantidad) || 0);
    let TC = cantArr.reduce((t, x) => t + x, 0);
    setTotalCantidad(TC);

    let importes = dataFinal.map((c) => parseFloat(c.total_costo) || 0);
    let TG = importes.reduce((t, x) => t + x, 0);
    setTotalGeneral(TG);

    // ✅ Cargar imagenes (igual que tu PDFOC)
const imagePromises = dataFinal.map(async (z) => {
  if (!z.idArticulo) {
    z.foto = process.env.PUBLIC_URL + "sinImagen.png";
    return;
  }

  try {
    const imgResponse = await axios.get(
      `${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`,
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      }
    );

    // Si Cloudinary tiene imagen, la usamos
    if (imgResponse?.data?.secure_url) {
      z.foto = imgResponse.data.secure_url;
    } else {
      z.foto = process.env.PUBLIC_URL + "sinImagen.png";
    }
  } catch (error) {
    // Si no hay imagen en Cloudinary o falla la consulta
    z.foto = process.env.PUBLIC_URL + "sinImagen.png";
  }
});

await Promise.all(imagePromises);


    // Data para PDF (✅ primera columna: foto)
    const data = dataFinal.map((a) => {
      totalCajas += a.cajas;

      return [
        a.foto, // ✅ imagen
        a.proveedor,
        a.articulo,
        a.nombreArticulo,
        new Intl.NumberFormat("en-US").format(a.pzasXcaja),
        new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.cantidad),
        new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.cajas),
        "$" + new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.FOB),
        "$" + new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.total_costo),
      ];
    });

    const dataPDFLimpia = data.filter((el) => el != null);

    // PDF
    const doc = new jsPDF("landscape", "mm", "a4", true);

    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);

    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 30, 30);

    doc.setFontSize(12);
    doc.text(`Contenedor # ${contenedor} ${numeroInterno}`, 20, 20);
    doc.text(`Fecha Embarque ${fechaEmbarque}`, 20, 25);
    doc.text(`Fecha Estimada ${fechaEstimada}`, 20, 30);
    doc.text(`Creado por ${creado}`, 20, 35);

    // ✅ estilo para “columna imagen” (igual concepto que tu PDFOC)
    const columnStyles = {
      0: { fontSize: 0.000001, textColor: [255, 255, 255], cellWidth: 16 }, // imagen
      1: { fontSize: 9 },
      2: { fontSize: 9 },
      3: { fontSize: 9 },
      4: { fontSize: 9, halign: "right" },
      5: { fontSize: 9, halign: "right" },
      6: { fontSize: 9, halign: "right" },
      7: { fontSize: 9, halign: "right" },
      8: { fontSize: 9, halign: "right" },
    };

    doc.autoTable({
      head: [
        [
          "", // ✅ imagen
          "Proveedor",
          "SKU",
          "Articulo",
          "Pzs Caja",
          "Cantidad",
          "Cajas",
          "FOB",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      theme: "grid",

      bodyStyles: {
        rowHeight: 18,
        valign: "middle",
      },

      columnStyles,

      footStyles: {
        fontSize: 12,
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
      },
      foot: [
        [
          "",
          "",
          "",
          "Total",
          "",
          new Intl.NumberFormat("en-US").format(TC),
          new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(totalCajas),
          "",
          "$" + new Intl.NumberFormat("en-US").format(TG),
        ],
      ],
      showFoot: "lastPage",

      // ✅ dibujar la imagen en la celda
      didDrawCell: function (data) {
        if (data.column.index === 0 && data.cell.section === "body") {
          var img = data.cell.raw; // aquí viene a.foto
          var textPos = data.cell;

          // (x,y,w,h) — ajusta si la quieres más grande
          doc.addImage(img, textPos.x + 1, textPos.y + 1, 14, 14);
        }
      },
    });

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.log(err);
  }
}

async function PDFOC(
  fechaEmbarque,
  contenedor,
  numeroInterno,
  fechaEstimada,
  creado,
  idPDFOC,
  numero
) {
  let totalCajas = 0;

  try {
    const response = await axios.get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idPDFOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    let allArticulosOrden = response.data || [];

    let arrayTabla = allArticulosOrden
      .map((a) => {
        const pzas = parseFloat(a?.articulos?.[0]?.piezasPorCaja || 0);
        const cant = parseFloat(a?.cantidad || 0);

        return {
          id: a._id,
          proveedor: a?.proveedores?.[0]?.nombre_comercial || "",
          articulo: a?.articulos?.[0]?.SKU || "",
          nombreArticulo: a?.articulos?.[0]?.nombre || "",
          pzasXcaja: pzas,
          cantidad: cant,
          cajas: pzas > 0 ? cant / pzas : 0,

          // ✅ para imagen
          idArticulo: a?.articulos?.[0]?._id,
          foto: "",
        };
      })
      .filter((el) => el != null);

    let dataFinal = Object.values(arrayTabla);

    // Totales
    let cant = dataFinal.map((c) => parseFloat(c.cantidad) || 0);
    let TC = cant.reduce((t, x) => t + x, 0);
    setTotalCantidad(TC);

    // (Ojo: aquí ya NO tienes total_costo en tu objeto, entonces quité TG)
    // Si no lo usas, puedes eliminar setTotalGeneral también.
    // setTotalGeneral(0);

    // ✅ Cargar imágenes desde Cloudinary (sin fotoArticulo)
    const imagePromises = dataFinal.map(async (z) => {
      if (!z.idArticulo) {
        z.foto = process.env.PUBLIC_URL + "sinImagen.png";
        return;
      }

      try {
        const imgResponse = await axios.get(
          `${process.env.REACT_APP_URL_GETMEDIA}/${z.idArticulo}`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        z.foto = imgResponse?.data?.secure_url
          ? imgResponse.data.secure_url
          : process.env.PUBLIC_URL + "sinImagen.png";
      } catch (error) {
        z.foto = process.env.PUBLIC_URL + "sinImagen.png";
      }
    });

    await Promise.all(imagePromises);

    // Data para tabla (✅ primera columna: imagen)
    const data = dataFinal.map((a) => {
      totalCajas += a.cajas;

      return [
        a.foto, // ✅ imagen
        a.proveedor,
        a.articulo,
        a.nombreArticulo,
        new Intl.NumberFormat("en-US").format(a.pzasXcaja),
        new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.cantidad),
        new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(a.cajas),
      ];
    });

    const dataPDFLimpia = data.filter((el) => el != null);

    // PDF
    const doc = new jsPDF("landscape", "mm", "a4", true);

    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);

    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 125, 10, 30, 30);

    doc.setFontSize(12);
    doc.text(`Contenedor # ${contenedor} ${numeroInterno}`, 20, 20);
    doc.text(`Fecha Embarque ${fechaEmbarque}`, 20, 25);
    doc.text(`Fecha Estimada ${fechaEstimada}`, 20, 30);
    doc.text(`Creado por ${creado}`, 20, 35);

    // ✅ columnStyles para “columna imagen”
    const columnStyles = {
      0: { fontSize: 0.000001, textColor: [255, 255, 255], cellWidth: 16 }, // imagen
      1: { fontSize: 9 },
      2: { fontSize: 9 },
      3: { fontSize: 9 },
      4: { fontSize: 9, halign: "right" },
      5: { fontSize: 9, halign: "right" },
      6: { fontSize: 9, halign: "right" },
    };

    doc.autoTable({
      head: [
        [
          "", // ✅ imagen
          "Proveedor",
          "SKU",
          "Articulo",
          "Pzs Caja",
          "Cantidad",
          "Cajas",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      theme: "grid",
      columnStyles,

      bodyStyles: {
        rowHeight: 18,
        valign: "middle",
      },

      // ✅ dibujar la imagen en la celda
      didDrawCell: function (data) {
        if (data.column.index === 0 && data.cell.section === "body") {
          var img = data.cell.raw; // url/imagen
          var pos = data.cell;

          // Ajusta tamaño si quieres más grande
          doc.addImage(img, pos.x + 1, pos.y + 1, 14, 14);
        }
      },
    });

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.log(err);
  }
}

  function validar(id) {
    const URL_AUTORIZADO = `${URL_EMBARQUES}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              validado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Good job!", "Validado", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
      }
    });
  }

      function desvalidar(id) {
    const URL_AUTORIZADO = `${URL_EMBARQUES}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              validado: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Good job!", "Desvalidado", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
      }
    });
  }


  function jalaInfo(
    fechaEmbarque,
    fechaEstimada,
    numeroInterno,
    kasher,
    tipoCambioUSDMXN,
    observaciones,
    contenedor,
    numero,
    recibido,
    idEdit
  ) {
    setFechaEmbarque(fechaEmbarque);
    setNumeroInterno(numeroInterno);
    setKasher(kasher);
    setFechaEstimada(fechaEstimada);
    setTipoCambioUSDMXN(tipoCambioUSDMXN);
    setObservaciones(observaciones);
    setContenedor(contenedor);
    setNumeroEmbarque(numero);
    setRecibidoEdit(recibido)
    setIdEdit(idEdit);
    toggleEdit();
  }

  function editEmbarques(event) {
    event.preventDefault();
    const URL_EMBARQUES_EDIT = `${process.env.REACT_APP_URL_EMBARQUES}/${idEdit}`;
    axios
      .all([
        axios.patch(
          URL_EMBARQUES_EDIT,
          {
            fechaEmbarque,
            fechaEstimada,
            numeroInterno,
            kasher,
            tipoCambioUSDMXN,
            observaciones,
            contenedor,
            recibido: recibidoEdit
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        ),
      ])
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Embarque",
            detalle: `${numeroEmbarque}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
        setComments((prev) =>
          prev.map((embarque) =>
            embarque._id === idEdit
              ? {
                  ...embarque,
                  fecha: fechaEmbarque,
                  fechaEstimada,
                  numeroInterno,
                  kasher,
                  tipoCambioUSDMXN,
                  observaciones,
                  contenedor,
                  recibido: recibidoEdit,
                }
              : embarque
          )
        );
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Activo", field: "is_active", sortable: true },
    { name: "Recibido", field: "recibido", sortable: true },
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha Embarque", field: "fechaEmbarque", sortable: false },
    { name: "Proveedor", field: "proveedor", sortable: false },
    { name: "Contenedor", field: "contenedor", sortable: true },
    { name: "Numero Interno", field: "numeroInterno", sortable: true },
    { name: "Kasher", field: "kasher", sortable: true },
    { name: "Costeado", field: "costeado", sortable: true },
    { name: "Fecha Estimada", field: "fechaEstimada", sortable: false },
    { name: "Cantidad", field: "totalCantidad", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.recibido.toLowerCase().includes(search.toLowerCase()) ||
          comment.is_active.toLowerCase().includes(search.toLowerCase()) ||
          comment.contenedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroInterno.toLowerCase().includes(search.toLowerCase()) ||
          comment.kasher.toLowerCase().includes(search.toLowerCase()) ||
          comment.costeado.toLowerCase().includes(search.toLowerCase()) ||
          comment.totalCantidad.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (recibido) {
      computedComments = computedComments.filter((e) =>
        e.recibido.includes(recibido)
      );
    }
    if (selectedCosteado) {
      computedComments = computedComments.filter((e) =>
        e.costeado.includes(selectedCosteado)
      );
    }

    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedor.includes(selectedProveedor)
      );
    }
     if (selectedKasher) {
      computedComments = computedComments.filter((e) =>
        e.kasher.includes(selectedKasher)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fechaEmbarque >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fechaEmbarque <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "totalCantidad" &&
      sorting.field &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "totalCantidad" ||
        sorting.field ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "totalCantidad" ||
        sorting.field ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    recibido,
    selectedCosteado,
    selectedProveedor,
    selectedKasher,
    selectedFechaInicio,
    selectedFechaFin,
  ]);

function EditArticulos(
  idOC,
  idProveedor,
  totalCantidad,
  total_costo,
  kasher,
  tipoCambio,
  total_gasto,
  costeado
) {
  setIdEdit(idOC);
  setIdProveedorEdit(idProveedor);
  setTotalCantidadEdit(totalCantidad);
  setTotalGeneralEdit(total_costo);
  setTipoCambio(tipoCambio);
  setTotalGastoPrecosteo(total_gasto); // 👈 ya lo tienes
  setCosteadoEdit(costeado);
  setKT(kasher);

  axios
    .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allArticulosPedido = response.data;
      let arrayTabla = allArticulosPedido
        .map((a) => {
          return {
            id: a._id,
            idArticulos: a.articulos[0]._id,
            articulo: a.articulos[0].SKU + " " + a.articulos[0].nombre,
            cantidad: a.cantidad,
            costoUSD: a.costoUSD,
            costoFactura: a.costoFactura ?? a.costoUSD,
            total: a.total_costo,
            CBM: a.CBM,
            comisionVendedorPorcentaje: a.comisionVendedorPorcentaje,
            comisionVendedorCantidad: a.comisionVendedorCantidad,
            igiPorcentaje: a.igiPorcentaje,
            tipoCambioUSDMXN: a.tipoCambioUSDMXN,
          };
        })
        .filter((el) => el != null);

      let dataFinal = Object.values(arrayTabla);

      // 🔥 Aquí calculamos "gastos" igual que en editCostear
      const conGastos = recalcularGastosPorCBM(dataFinal, total_gasto);

      setArticulosPedido(conGastos);
    })
    .catch((err) => {
      console.log(err);
    });

  if (kasher === "Taref") {
    toggleEditFOB();
  } else if (kasher === "Kasher") {
    toggleEditFOBKasher();
  }
}

const handleCostoChange = (index, value) => {
  const nuevosArticulos = [...articulosPedido];
  nuevosArticulos[index].costoUSD = parseFloat(value) || 0; // Convertir a número seguro
  setArticulosPedido(nuevosArticulos);
};
const handleCostoFacturaChange = (index, value) => {
  const nuevosArticulos = [...articulosPedido];
  nuevosArticulos[index].costoFactura = parseFloat(value) || 0; // Convertir a número seguro
  setArticulosPedido(nuevosArticulos);
};

const handleGastosChange = (index, value) => {
  const nuevo = [...articulosPedido];
  nuevo[index] = {
    ...nuevo[index],
    gastos: Number(value) || 0,
  };
  setArticulosPedido(nuevo);
};

const handleCBMChange = (index, value) => {
  const nuevos = [...articulosPedido];

  nuevos[index] = {
    ...nuevos[index],
    CBM: Number(value) || 0,
  };
  const conGastos = recalcularGastosPorCBM(nuevos, totalGastoPrecosteo);
  setArticulosPedido(conGastos);
};
const handleIgiChange = (index, value) => {
  const nuevos = [...articulosPedido];
  nuevos[index] = {
    ...nuevos[index],
    igiPorcentaje: Number(value) || 0,
  };
  setArticulosPedido(nuevos);
};

  const handleComisionChange = (index, value) => {
    const nuevosArticulos = [...articulosPedido];
    const porcentaje = parseFloat(value) || 0;
    const fob = parseFloat(nuevosArticulos[index].costoUSD) || 0;
  
    nuevosArticulos[index].comisionVendedorPorcentaje = porcentaje;
    nuevosArticulos[index].comisionVendedorCantidad = (fob * porcentaje) / 100;
  
    setArticulosPedido(nuevosArticulos);
  };

    const handleCBMChangeNuevos = (index, value) => {
    const nuevosArticulos = [...inputFieldsNuevos];
    nuevosArticulos[index].CBM = value;
    setInputFieldsNuevos(nuevosArticulos);
  };
  const handleComisionChangeNuevos = (index, value) => {
    const nuevosArticulos = [...inputFieldsNuevos];
    const porcentaje = parseFloat(value) || 0;
    const fob = parseFloat(nuevosArticulos[index].costoUSD) || 0;
  
    nuevosArticulos[index].comisionVendedorPorcentaje = porcentaje;
    nuevosArticulos[index].comisionVendedorCantidad = (fob * porcentaje) / 100;
  
    setInputFieldsNuevos(nuevosArticulos);
  };

  const recalcularGastosPorCBM = (items, totalGasto) => {
  if (!items || !items.length || !totalGasto) return items;

  // 1) CBM total del embarque = Σ (CBMpieza * cantidad)
  const totalCBM = items.reduce((acc, a) => {
    const cantidad = Number(a.cantidad) || 0;
    const cbmPieza = Number(a.CBM) || 0; // CBM por pieza
    // return acc + cbmPieza * cantidad;
    return acc + cbmPieza;
  }, 0);

  if (!totalCBM) {
    // evitar división entre 0
    return items.map(a => ({ ...a, gastos: 0 }));
  }

  // 2) Gasto por CBM
  const gastoPorCBM = totalGasto / totalCBM;

  // 3) Gasto por pieza
  return items.map(a => {
  // CBM por pieza
      const cbmTotal = Number(a.CBM) || 0;
  const cbmPieza = a.cantidad > 0 ? cbmTotal / a.cantidad : 0;

    const gastoPorPieza = cbmPieza * gastoPorCBM;

    return {
      ...a,
      gastos: Number(gastoPorPieza.toFixed(2)), // ya redondeado a 2 decimales
    };
  });
};
const saveFOBEmbarque = async (event, costear = false) => {
  event.preventDefault();
  setValidaBoton(false);
  toggleProgreso();

  try {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // 1. PATCH de artículos del embarque (FOB, CBM, comisiones)
    await Promise.all(
      articulosPedido.map((a) =>
        axios.patch(
          `${URL_ARTICULOS_EMBARQUES}EditFOB/${a.id}`,
          {
            costoUSD: parseFloat(a.costoUSD),
            costoFactura: parseFloat(a.costoFactura),
            igiPorcentaje: parseFloat(a.igiPorcentaje),
            CBM: parseFloat(a.CBM),
            comisionVendedorPorcentaje: parseFloat(
              a.comisionVendedorPorcentaje
            ),
            comisionVendedorCantidad: parseFloat(
              a.comisionVendedorCantidad
            ),
          },
          { headers }
        )
      )
    );

    // 2. Si "Guardar y costear": ACTUALIZAR CATÁLOGO PRIMERO.
    //    Si el catálogo falla, no marcamos el embarque como costeado y el usuario
    //    puede reintentar. (Antes esto iba al final y dejaba embarques costeados="Si"
    //    con el catálogo desactualizado si algo reventaba en medio.)
    if (costear) {
      const calcCostoMX = (a) => {
        const tipo = String(KT || "").trim().toLowerCase();
        const gastos = Number(a.gastos) || 0;
        const costoUSDBase = Number(a.costoUSD) || 0;
        const comision = Number(a.comisionVendedorCantidad) || 0;
        const costoUSDTotal = costoUSDBase + comision;

        // Tipo de cambio POR ARTÍCULO (alimentado de anticipos/pagos vía
        // ArticulosEmbarques.tipoCambioUSDMXN); si el artículo no tiene TC
        // propio, se usa el tipo de cambio del embarque como respaldo.
        const tc = Number(a.tipoCambioUSDMXN) > 0
          ? Number(a.tipoCambioUSDMXN)
          : (Number(tipoCambio) || 0);

        if (tipo === "taref") {
          const costoPesos = costoUSDTotal * tc;
          return Number((costoPesos + gastos).toFixed(2));
        }

        const costoFactura = Number(a.costoFactura ?? a.costoUSD) || 0;
        const igiPorcentaje = Number(a.igiPorcentaje ?? 0) || 0;
        const declaradoPesos = costoFactura * tc;
        const dta = declaradoPesos * 0.008;
        const igi = declaradoPesos * (igiPorcentaje / 100);
        const baseIVA = declaradoPesos + dta + igi;
        const iva = baseIVA * 0.16;
        const impuestos = dta + igi + iva;
        const costoPesos = costoUSDTotal * tc;
        return Number((impuestos + costoPesos + gastos).toFixed(2));
      };

      await Promise.all(
        articulosPedido.map((a) => {
          const costoMX = calcCostoMX(a);
          return axios.patch(
            `${URL_ARTICULOS}/${a.idArticulos}`,
            { costoMX },
            { headers }
          );
        })
      );
    }

    // 3. PATCH al embarque principal (totales) + opcional costeado="Si"
    //    Este paso corre DESPUÉS del catálogo: si el catálogo falla, el
    //    embarque NO queda marcado como costeado.
    const embarquePayload = {
      total_cantidad: totalCantidadEdit,
      total_costo: parseFloat(totalGeneralEdit).toFixed(2),
      saldo: parseFloat(totalGeneralEdit).toFixed(2),
    };

    if (costear) {
      embarquePayload.costeado = "Si";
    }

    await axios.patch(`${URL_EMBARQUES}/${idEdit}`, embarquePayload, {
      headers,
    });

    // 3. Si hay artículos nuevos, los procesamos igual que antes
    const nuevosConArticulo = inputFieldsNuevos.filter(
      (a) => a.articulos !== ""
    );

    if (nuevosConArticulo.length > 0) {
      // 3.1 Agrupar nuevos artículos por proveedor
      const agrupadoPorProveedor = [];
      nuevosConArticulo.forEach((a) => {
        const existente = agrupadoPorProveedor.find(
          (p) => p.proveedor === a.proveedorOrden
        );
        if (existente) {
          existente.cantidad += a.cantidad;
          existente.costoTotal += a.costoTotal;
        } else {
          agrupadoPorProveedor.push({
            proveedor: a.proveedorOrden,
            cantidad: a.cantidad,
            costoTotal: a.costoTotal,
          });
        }
      });

      // 3.2 Crear nueva Nota CxP
      const notaCxPGuardada = await axios
        .post(
          `${URL_NOTAS_CXP}`,
          {
            proveedores: nuevosConArticulo[0].proveedorOrden,
            embarques: idEdit,
            total_cantidad: totalCantidadEdit,
            total_costo: parseFloat(totalGeneralEdit).toFixed(2),
            saldo: parseFloat(totalGeneralEdit).toFixed(2),
            calidad: "No",
            fecha: hoy,
          },
          { headers }
        )
        .then((res) => res.data);

      // 3.3 Insertar nuevos artículos al embarque con la nota ligada
      await Promise.all(
        nuevosConArticulo.map((a) =>
          axios.post(
            `${URL_ARTICULOS_EMBARQUES}`,
            {
              articulosOC: a.articulosOrden,
              articulos: a.articulos,
              cantidad: a.cantidad,
              CBM: a.CBM,
              recibido: 0,
              pendiente_recibir: a.cantidad,
              embarques: idEdit,
              notasCxP: notaCxPGuardada._id.toString(),
              costo: a.costo,
              total_costo: a.costoTotal,
              proveedores: a.proveedorOrden,
              faltante: 0,
              danado: 0,
              impuestos: 0,
              revisarFaltante: 10,
              revisarDanado: 10,
              pedirFaltante: 0,
              pedirDanado: 10,
              faltanteTotal: 0,
              danadoTotal: 0,
              descuentoFaltante: 0,
              descuentoDanado: 0,
              descuentoTotal: 0,
              familias: "NA",
              sup: "NA",
              observaciones: "NA",
              calidad: "No",
              costoUSD: a.costoUSD,
              costoFactura: a.costoFactura,
              comisionVendedorPorcentaje: a.comisionVendedorPorcentaje,
              comisionVendedorCantidad: a.comisionVendedorCantidad,
            },
            { headers }
          )
        )
      );

      // 3.4 PATCH a artículos OC (por línea de OC)
      await Promise.all(
        nuevosConArticulo.map((w) =>
          axios.patch(
            `${URL_ARTICULOS_OC}editEmbarcado/${w.articulosOrden}`,
            {
              embarcado: w.cantidad,
              ordenesCompra: w.ordenCompra,
            },
            { headers }
          )
        )
      );
    }

    // 4. Si el usuario eligió "Guardar y costear", actualizamos ARTICULOS.costoMX
    // if (costear) {
    //   await Promise.all(
    //     articulosPedido.map((a) => {
    //       const cantidad = Number(a.cantidad) || 0;
    //       const costoUSD = Number(a.costoUSD) || 0;
    //       const costoFactura = Number(a.costoFactura ?? a.costoUSD) || 0;
    //       const gastos = Number(a.gastos) || 0;

    //       const declaradoPesos = costoFactura * tipoCambio;
    //       const dta = declaradoPesos * 0.008;
    //       const igi = declaradoPesos * a.igiPorcentaje / 100;
    //       const baseIVA = declaradoPesos + dta + igi;
    //       const iva = baseIVA * 0.16;
    //       const impuestos = dta + igi + iva;
    //       const costoPesos = costoUSD * tipoCambio;
    //       const costoUnitario = impuestos + costoPesos + gastos;

    //       const costoMX = parseFloat(costoUnitario.toFixed(2));
    //       return axios.patch(
    //         `${URL_ARTICULOS}/${a.idArticulos}`, // 👈 ajusta si tu ruta es distinta
    //         { costoMX },
    //         { headers }
    //       );
    //     })
    //   );
    // }
    // Nota: el bloque "if (costear) { PATCH catálogo }" se movió arriba,
    // antes del PATCH que marca el embarque como costeado.

    // 5. Guardar log
    await axios.post(
      URL_LOGS,
      {
        tipo: costear
          ? "Editar Articulos Embarque + Costeo"
          : "Editar Articulos Embarque",
        detalle: `${idEdit}`,
        user: user.id,
      },
      { headers }
    );

    Swal.fire(
      "¡Correcto!",
      costear
        ? "Actualización y costeo exitosos"
        : "Actualización exitosa",
      "success"
    );
  } catch (error) {
    console.error("Error en la actualización:", error);
    Swal.fire(
      "Error",
      "Hubo un problema al guardar algunos artículos",
      "warning"
    );
  }

  setModalProgreso(false);
  setValidaBoton(true);
};


  function EditGastos(id, total_gasto) {
    setGastosEmbarquesTotales(Number(total_gasto) || 0);
    axios
      .get(`${URL_GASTOS_EMBARQUES}Embarque/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allGastosEmbarque = res.data;
        setGastosEmbarque(allGastosEmbarque);
        console.log(allGastosEmbarque);
      })
      .catch((err) => {
        console.log(err);
      });

    setInputFieldsGastos([
      {
        id: uuidv4(),
        concepto: "",
        estimado: 0,
        real: 0,
        proveedores: "",
        fecha: new Date().toISOString().split("T")[0],
      },
    ]);
    setIdEdit(id);

    toggleEditGastos();
  }

  function costear(id) {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Se realizará el costeo del embarque. Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, costear embarque",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${URL_EMBARQUES}Costear/${id}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            Swal.fire({
              title: "¡Listo!",
              text: "El embarque fue costeado correctamente.",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
          })
          .catch((err) => {
            console.error(err);
            Swal.fire({
              title: "Error",
              text: "Ocurrió un error al costear el embarque.",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          });
  
        setIdEdit(id);
      }
    });
  }
  

  const handleRemoveFieldsGastos = (id) => {
    const values = [...inputFieldsGastos];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsGastos(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidadGastos(TC);
  };

  const handleAddFieldsGastos = () => {
    setInputFieldsGastos([
      ...inputFieldsGastos,
      {
        id: uuidv4(),
        concepto: "",
        estimado: 0,
        real: 0,
        proveedores: "",
        fecha: new Date().toISOString().split("T")[0],
      },
    ]);
  };

  const handleChangeInputGastos = (id, event) => {
    const newInputFieldsGastos = inputFieldsGastos.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsGastos(newInputFieldsGastos);
    ActualizaTotalesGastos()
  };

  const handleChangeInputGastosExistentes = (id, event) => {
    const newGastosEmbarque = gastosEmbarque.map((i) => {
      if (id === i._id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setGastosEmbarque(newGastosEmbarque);
    ActualizaTotalesGastos()
  };

  function ActualizaTotalesGastos() {
    let TEfe = gastosEmbarque.map((c) => parseFloat(c.real) || 0);
    let TE = TEfe.reduce((t, total, index) => t + total, 0);

    let TEfeNC = inputFieldsGastos.map((c) => parseFloat(c.real) || 0);
    let TENC = TEfeNC.reduce((t, total, index) => t + total, 0);

    let TF = parseFloat(TE).toFixed(2)
    let TFNC = parseFloat(TENC).toFixed(2)

    let sum = (parseFloat(TF) + parseFloat(TFNC)).toFixed(2)

    setGastosEmbarquesTotales(sum);

  }

  function BuscaGasto(id, event) {
    if (
      inputFieldsGastos.filter((e) => e.concepto == event.target.value).length >
      0
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El gasto ya fue capturado!",
        showConfirmButton: false,
      });
      const newInputFieldsGastos = inputFieldsGastos.map((i) => {
        if (id === i.id) {
          i.concepto = "";
        }
        return i;
      });
      setInputFieldsGastos(newInputFieldsGastos);
    } else {
      conceptosGastos.map((a) => {
        if (a._id == event.target.value) {
          let concepto = a._id;
          let estimado = a.estimado;
          handleChangeInputGasto(id, concepto, estimado);
        }
      });
    }
  }
  const handleChangeInputGasto = (id, concepto, estimado) => {
    const newInputFieldsGasto = inputFieldsGastos.map((i) => {
      if (id === i.id) {
        i.concepto = concepto;
        i.estimado = estimado;
        i.real = estimado;
      }
      return i;
    });
    setInputFieldsGastos(newInputFieldsGasto);
  };

  const saveGastosEmbarque = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();
    let totalEmbarques = inputFieldsGastos.length + gastosEmbarque.length;
    try {
      await inputFieldsGastos.map((a) => {
        if (a.concepto != "") {
          axios
            .post(
              URL_GASTOS_EMBARQUES,
              {
                conceptosGastosEmbarques: a.concepto,
                estimado: a.estimado,
                real: a.real,
                embarques: idEdit,
                proveedores: a.proveedores || null,
                fecha: a.fecha || null,
                gastosEmbarquesTotales
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              totalEmbarques = totalEmbarques - 1;
              if (totalEmbarques == 0) {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Editar Gastos Embarque",
                    detalle: `${idEdit}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire("Good job!", "Creado con exito", `success`);
                 setValidaBoton(true);
              setModalProgreso(false)  
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        } else {
          totalEmbarques = totalEmbarques - 1;
          if (totalEmbarques == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Gastos",
                detalle: `${idEdit}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
             setValidaBoton(true);  
              setModalProgreso(false)
            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          }
        }
      });

      gastosEmbarque.map((a) => {
        if (a.concepto != "") {
          axios
            .patch(
              `${URL_GASTOS_EMBARQUES}/${a._id}`,
              {
                estimado: a.estimado,
                real: a.real,
                embarques: idEdit,
                proveedores:
                  (typeof a.proveedores === "string"
                    ? a.proveedores
                    : a.proveedores?.[0]?._id) || null,
                fecha: a.fecha || null,
                gastosEmbarquesTotales
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              totalEmbarques = totalEmbarques - 1;
              if (totalEmbarques == 0) {
                axios.post(
                  URL_LOGS,
                  {
                    tipo: "Editar Gastos Embarque",
                    detalle: `${idEdit}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                );
                Swal.fire("Good job!", "Creado con exito", `success`);
                 setValidaBoton(true);  
              setModalProgreso(false)
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        } else {
          totalEmbarques = totalEmbarques - 1;
          if (totalEmbarques == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Gastos",
                detalle: `${idEdit}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
             setValidaBoton(true); 
              setModalProgreso(false) 
            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          }
        }
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  // function EditArticulos(idOC, contenedor, idProveedor, idContenedor) {
  //   setInputFields([
  //     {
  //       id: uuidv4(),
  //       articulosOrden: "",
  //       articulos: "",
  //       cantidad: 0,
  //       cantidadAnterior: 0,
  //       piezasPorCaja: 0,
  //       cajas: 0,
  //       cantidadOC: 0,
  //       costo: 0,
  //       costoTotal: 0,
  //       proveedorOrden: "",
  //       notasCxP: "",
  //     },
  //   ]);
  //   setInputFieldsNuevos([
  //     {
  //       id: uuidv4(),
  //       articulosOrden: "",
  //       articulos: "",
  //       cantidad: 0,
  //       piezasPorCaja: 0,
  //       cajas: 0,
  //       cantidadOC: 0,
  //       costo: 0,
  //       costoTotal: 0,
  //       proveedorOrden: idProveedor,
  //       ordenCompra: ""
  //     },
  //   ]);
  //   setIdArtEdit(idOC);
  //   setContenedorEdit(contenedor);
  //   setIdProveedor(idProveedor);
  //   setIdContenedor(idContenedor);
  //   setIdNotaCxP("");
  //   axios
  //     .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${idOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosOrden = response.data;
  //       let arrayTabla = allArticulosOrden
  //         .map((a) => {
  //           return {
  //             id: a._id,
  //             articulosOrden: a.articulosOC[0]._id,
  //             articulos: a.articulos[0]._id,
  //             cantidad: a.cantidad,
  //             cantidadAnterior: a.cantidad,
  //             piezasPorCaja: a.articulos[0].piezasPorCaja,
  //             cajas:
  //               parseFloat(a.cantidad) /
  //               parseFloat(a.articulos[0].piezasPorCaja),
  //             cantidadOC: a.articulosOC[0].cantidad,
  //             costo: a.costo,
  //             costoTotal: a.total_costo,
  //             proveedorOrden: a.proveedores[0]._id,
  //             notasCxP: a.notasCxP[0]._id,
  //             costoNotasCxP: a.notasCxP[0].total_costo,
  //             saldoNotasCxP: a.notasCxP[0].saldo,
  //             ordenCompra: a.articulosOC[0].ordenesCompra[0]._id,
  //           };
  //         })
  //         .filter(function (el) {
  //           return el != null;
  //         });
  //       let dataFinal = Object.values(arrayTabla);
  //       setArticulosOrden(dataFinal);
  //       let cant = dataFinal.map((c) => parseFloat(c.cantidad));
  //       let TC = cant.reduce((t, total, index) => t + total, 0);
  //       setTotalCantidadEdit(TC);
  //       let importes = dataFinal.map((c) => parseFloat(c.total));
  //       let TG = importes.reduce((t, total, index) => t + total, 0);
  //       setTotalGeneralEdit(TG);

  //       let nota = dataFinal.map((c) => c.notasCxP);
  //       // let nota = dataFinal.map((c) => c.notasCxP);
  //       // let notaTT = nota[0].reduce((t, total, index) => t + total, 0);
  //       setIdNotaCxP(nota[0]);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  //   toggleEditArticulos();
  // }

 function ActualizaTotales() {
  // Total cantidades de artículos existentes
  let cant = articulosPedido.map((c) => parseFloat(c.cantidad));
  let TC = cant.reduce((t, total) => t + total, 0);

  // Total costos de artículos existentes
  let cos = articulosPedido.map((c) => parseFloat(c.total));
  let TCos = cos.reduce((t, total) => t + total, 0);

  // Filtrar artículos nuevos válidos
  const nuevosConArticulo = inputFieldsNuevos.filter((c) => c.articulos !== "");

  if (nuevosConArticulo.length > 0) {
    // Sumar cantidades de artículos nuevos
    let cantNu = nuevosConArticulo.map((c) => parseFloat(c.cantidad));
    let TCNu = cantNu.reduce((t, total) => t + total, 0);

    // Sumar costos de artículos nuevos
    let cosNu = nuevosConArticulo.map((c) => parseFloat(c.costoTotal));
    let TCosNu = cosNu.reduce((t, total) => t + total, 0);

    // Totales combinados
    setTotalCantidadEdit(TC + TCNu);
    setTotalGeneralEdit(TCos + TCosNu);
  } else {
    // Solo tomar en cuenta los actuales
    setTotalCantidadEdit(TC);
    setTotalGeneralEdit(TCos);
  }

  // Agrupación por notaCxP para artículos existentes
  let agrupado = articulosPedido.reduce(function (groups, item) {
    const val = item["notasCxP"];
    groups[val] = groups[val] || {
      notasCxP: item.notasCxP,
      costoTotal: 0,
      cantidad: 0,
    };
    groups[val].proveedorOrden = item.proveedorOrden;
    groups[val].costoTotal += item.costoTotal;
    groups[val].cantidad += item.cantidad;
    groups[val].notasCxP = item.notasCxP;
    groups[val].saldoNotasCxP = item.saldoNotasCxP;
    groups[val].costoNotasCxP = item.costoNotasCxP;
    return groups;
  }, []);
  
  let temp = Object.values(agrupado);
  setAgrupado(temp);
}


  const handleChangeInputCantidad = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        i.costoTotal = parseFloat(event.target.value) * parseFloat(i.costo);
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const handleChangeInputCantidadCajas = (id, event) => {
    const newArticulosOrden = articulosOrden.map((i) => {
      if (id === i.id) {
        let cantTemp =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i[event.target.name] = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i.costoTotal =
          parseFloat(event.target.value) *
          parseFloat(i.piezasPorCaja) *
          parseFloat(i.costo);
      }
      return i;
    });
    setArticulosOrden(newArticulosOrden);
    ActualizaTotales();
  };

  const saveEditArt = async (event) => {
    event.preventDefault();

    setValidaBoton(false);
    toggleProgreso();

    let totalArticulos = articulosOrden.length + articulosOrden.length + agrupado.length + inputFieldsNuevos.length + inputFieldsNuevos.length
    let TCosto = articulosOrden.map((c) => parseFloat(c.costoTotal));
    let TTC = TCosto.reduce((t, total, index) => t + total, 0);

    let TCostoNuevo = inputFieldsNuevos.map((c) => parseFloat(c.costoTotal));
    let TTCNu = TCostoNuevo.reduce((t, total, index) => t + total, 0);

    let TCantNuevo = inputFieldsNuevos.map((c) => parseFloat(c.cantidad));
    let TTCantNu = TCantNuevo.reduce((t, total, index) => t + total, 0);

    let totalTotal = TTC + TTCNu
    try {
      await axios
        .patch(
          `${URL_EMBARQUES}/${idArtEdit}`,
          {
            total_cantidad: totalCantidadEdit,
            total_costo: parseFloat(totalTotal).toFixed(2),
            saldo: parseFloat(totalTotal).toFixed(2),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          agrupado.map((b) => {
            axios
              .patch(
                `${URL_NOTAS_CXP}editEmbarque/${idNotaCxP}`,
                {
                  proveedores: b.proveedorOrden,
                  total_cantidad: b.cantidad + TTCantNu,
                  total_costo: parseFloat(totalTotal).toFixed(2),
                  saldo:
                    parseFloat(b.saldoNotasCxP) -
                    parseFloat(b.costoNotasCxP) +
                    parseFloat(b.costoTotal) +
                    parseFloat(TTCNu),
                  difSaldo:
                    parseFloat(b.costoTotal + TTCNu) - parseFloat(b.costoNotasCxP),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Editar Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire(
                        "Good job!",
                        "Creado con exito",
                        "success"
                      );
                       setValidaBoton(true);  
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });

            // Acaba el primer map
          });

          articulosOrden.map((j) => {
            axios
              .patch(
                `${URL_ARTICULOS_EMBARQUES}EditCant/${j.id}`,
                {
                  cantidad: j.cantidad - j.cantidadAnterior,
                  total_costo: j.costoTotal,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire(
                        "Good job!",
                        "Creado con exito",
                        "success"
                      );
                       setValidaBoton(true);  
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          });

          articulosOrden.map((w) => {
            axios
              .patch(
                `${URL_ARTICULOS_OC}editEmbarcadoCant/${w.articulosOrden}`,
                {
                  embarcado: w.cantidad - w.cantidadAnterior,
                  ordenesCompra: w.ordenCompra
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                       setValidaBoton(true);  
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          });

          // Acaba el segundo map
        })
        // Catch primer then
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });

        // Articulos Nuevos
        inputFieldsNuevos.map((a) => {
          if (
            a.articulos != "" &&
            a.cantidad != 0 
          ) {
            axios
              .post(
                `${URL_ARTICULOS_EMBARQUES}`,
                {
                  articulosOC: a.articulosOrden,
                  articulos: a.articulos,
                  cantidad: a.cantidad,
                  recibido: 0,
                  pendiente_recibir: a.cantidad,
                  embarques: idArtEdit,
                  notasCxP: idNotaCxP,
                  costo: a.costo,
                  total_costo: a.costoTotal,
                  proveedores: idProveedor,
                  faltante: 0,
                  danado: 0,
                  impuestos: 0,
                  revisarFaltante: 10,
                  revisarDanado: 10,
                  pedirFaltante: 0,
                  pedirDanado: 10,
                  faltanteTotal: 0,
                  danadoTotal: 0,
                  descuentoFaltante: 0,
                  descuentoDanado: 0,
                  descuentoTotal: 0,
                  familias: "NA",
                  sup: "NA",
                  observaciones:"NA",
                  calidad:"No"
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Embarque",
                        detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire(
                        "Good job!",
                        "Creado con exito",
                        "success"
                      );
                       setValidaBoton(true);  
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          } else {
            totalArticulos = totalArticulos - 1;
            if (totalArticulos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Crear Embarque",
                    detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire(
                    "Good job!",
                    "Creado con exito",
                    "success"
                  );
                   setValidaBoton(true);  
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });

        inputFieldsNuevos.map((w) => {
          if (
            w.articulos != "" &&
            w.cantidad != 0 
          ) {
          axios
            .patch(
              `${URL_ARTICULOS_OC}editEmbarcado/${w.articulosOrden}`,
              {
                embarcado: w.cantidad,
                ordenesCompra: w.ordenCompra
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            )
            .then(() => {
              totalArticulos = totalArticulos - 1;
              if (totalArticulos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Embarque",
                      detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                     setValidaBoton(true);  
                    // setTimeout(() => {
                    //   window.location.reload();
                    // }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
              setValidaBoton(true);
            });
          } else {
            totalArticulos = totalArticulos - 1;
            if (totalArticulos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Crear Embarque",
                    detalle: `Fecha Embarque ${fechaEmbarque} / Contenedor ${contenedor}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire(
                    "Good job!",
                    "Creado con exito",
                    "success"
                  );
                   setValidaBoton(true);  
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });


    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        // footer: `${error.response.data}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  };

function BuscaArticulo(id, event) {
  const idArticuloSeleccionado = event.target.value;
  const articuloOC = articulosOC.find((a) => a._id === idArticuloSeleccionado);

  if (!articuloOC) return;

  const idArticulo = articuloOC.articulos[0]._id;

  // Verificar si ya existe en inputFieldsNuevos
  const yaExisteEnNuevos = inputFieldsNuevos.some(
    (i) => i.articulos === idArticulo
  );

  // Verificar si ya existe en articulosPedido
  const yaExisteEnPedido = articulosPedido.some(
    (i) => i.idArticulos === idArticulo
  );

  if (yaExisteEnNuevos || yaExisteEnPedido) {
    Swal.fire({
      icon: "warning",
      title: "Artículo ya agregado",
      text: "Este artículo ya se encuentra en la lista.",
    });
    return;
  }

  let articulosOrden = articuloOC._id;
  let articulos = idArticulo;
  let cantidad = articuloOC.pendiente_embarcar;
  let pendEmbarcar = articuloOC.pendiente_embarcar;
  let piezasPorCaja = articuloOC.articulos[0].piezasPorCaja;
  let cajas = articuloOC.cantidad / piezasPorCaja;
  let cantidadOC = articuloOC.cantidad;
  let costo = articuloOC.articulos[0].costoUSD;
  let costoUSD = articuloOC.articulos[0].costoUSD;
  let costoTotal = cantidadOC * costo;
  let proveedorOrden = idProveedorEdit;

  handleChangeInputArticulo(
    id,
    articulosOrden,
    articulos,
    cantidad,
    pendEmbarcar,
    piezasPorCaja,
    cajas,
    cantidadOC,
    costo,
    costoUSD,
    costoTotal,
    proveedorOrden
  );
}


  const handleChangeInputArticulo = (id, articulosOrden, articulos, cantidad, pendEmbarcar, piezasPorCaja, cajas, cantidadOC, costo, costoUSD, costoTotal, proveedorOrden) => {
    const newInputFields = inputFieldsNuevos.map((i) => {
      if (id === i.id) {
        i.articulosOrden = articulosOrden;
        i.articulos = articulos;
        i.cantidad = cantidad;
        i.pendEmbarcar = pendEmbarcar;
        i.piezasPorCaja = piezasPorCaja;
        i.cajas = cajas;
        i.cantidadOC = cantidadOC;
        i.costo = costo;
        i.costoUSD = costoUSD;
        i.costoTotal = costoTotal;
        i.proveedorOrden = proveedorOrden;
        i.CBM = 0;
        i.comisionVendedorPorcentaje = 0;
        i.comisionVendedorCantidad = 0;
      }
      return i;
    });
    setInputFieldsNuevos(newInputFields);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    let TC = totalCaptura + 1;

    setTotalCaptura(TC);
    setInputFieldsNuevos([
      ...inputFieldsNuevos,
      {
        id: uuidv4(),
        articulosOrden: "",
        articulos: "",
        cantidad: 0,
        pendEmbarcar: 0,
        CBM: 0,
        piezasPorCaja: 0,
        cajas: 0,
        cantidadOC: 0,
        costo: 0,
        costoUSD: 0,
        costoTotal: 0,
        proveedorOrden: idProveedorEdit,
        comisionVendedorPorcentaje: 0,
        comisionVendedorCantidad: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFieldsNuevos];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsNuevos(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let agrupado = values.reduce(function (groups, item) {
      const val = item["proveedorOrden"];
      groups[val] = groups[val] || {
        proveedorOrden: item.proveedorOrden,
        costoTotal: 0,
        cantidad: 0,
      };
      groups[val].proveedorOrden = item.proveedorOrden;
      groups[val].costoTotal += item.costoTotal;
      groups[val].cantidad += item.cantidad;
      return groups;
    }, []);
    let temp = Object.values(agrupado)
 setAgrupado(temp)
  };

const handleChangeInputCosto = (event, id) => {
  const { name, value } = event.target;

  const newInputFields = inputFieldsNuevos.map((i) => {
    if (id === i.id) {
      i[name] = parseFloat(value) || 0;
      i.costo = parseFloat(value) || 0;
      i.costoUSD = parseFloat(value) || 0;
      i.costoTotal = i.cantidad * i.costo;
    }
    return i;
  });

  setInputFieldsNuevos(newInputFields);
  ActualizaTotales();
};

  function BuscaOrden(id, event) {
    articulosOC.map((a) => {
      if (a._id == event.target.value) {
        let articulosOrden = a._id;
        let cantidadOC = a.cantidad;
        let costo = a.precio
        let ordenCompra = a.ordenesCompra[0]._id
        handleChangeInputOC(id, articulosOrden, cantidadOC, costo, ordenCompra);
      }
    });
  }
  const handleChangeInputOC = (id, articulosOrden, cantidadOC, costo, ordenCompra) => {
    const newInputFieldsNuevos = inputFieldsNuevos.map((i) => {
      if (id === i.id) {
        i.articulosOrden = articulosOrden;
        i.cantidadOC = cantidadOC;
        i.costo = costo;
        i.costoTotal = parseFloat(costo) * parseFloat(i.cantidad);
        i.ordenCompra = ordenCompra;
      }
      return i;
    });
    setInputFieldsNuevos(newInputFieldsNuevos);
    ActualizaTotales();
  };
  const handleChangeInputCantidadNuevos = (id, event) => {
    const newInputFieldsNuevos = inputFieldsNuevos.map((i) => {
      if (id === i.id) {
        if(event.target.value <= i.pendEmbarcar || event.target.value == "") {
        i[event.target.name] = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / parseFloat(i.piezasPorCaja);
        i.costoTotal = parseFloat(event.target.value) * parseFloat(i.costoUSD);
        }else{
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "La cantidad excede el pendiente embarcar!",
          });
          i[event.target.name] = 0
          i.cajas = 0
        }
      }
      return i;
    });
    setInputFieldsNuevos(newInputFieldsNuevos);
    ActualizaTotales();
  };

  const handleChangeInputCantidadCajasNuevos = (id, event) => {
    const newInputFieldsNuevos = inputFieldsNuevos.map((i) => {
      if (id === i.id) {
        let cantTemp =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i[event.target.name] = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        i.costoTotal =
          parseFloat(event.target.value) *
          parseFloat(i.piezasPorCaja) *
          parseFloat(i.costo);
      }
      return i;
    });
    setInputFieldsNuevos(newInputFieldsNuevos);
    ActualizaTotales();
  };


  return (
    <>
      <Header />
      <br />
      <br />
      {user.embarques ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.embarques ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/EmbarquesCreate"
                >
                  Nuevo Embarque
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Embarque
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuCompras"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                {/* <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={
                    e=>{
                      axios
                      .get(`${URL_ARTICULOS_EMBARQUES}Desarrollo`, {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      })
                      .then((response) => {
                        alert(response.data)
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                    }
                  }
                >
                  Desarrollo <i class="far fa-file-pdf"></i>
                </Button> */}
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes de Embarque</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Embarques</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio Embarque</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin Embarque</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
<Col md={2}>
              <Label>Proveedor</Label>
             <Input
                              bsSize="sm"
                              type="select"
                              value={selectedProveedor}
                              onChange={(e) => {
                                setSelectedProveedor(e.target.value);
                                setCurrentPage(1);
                              }}
                            >
                              <option value="">Selecciona</option>
                              {proveedores
                                .sort((a, b) =>
                                  a.nombre_comercial > b.nombre_comercial ? 1 : -1
                                )
                                .map((a) => {
                                  return (
                                    <option value={a._id}>{a.codigo} - {a.nombre_comercial}</option>
                                  );
                                })}
                            </Input>
                            </Col>
            <Col md={1}>
              <Label>Recibido</Label>
              <Input
                bsSize="sm"
                type="select"
                value={recibido}
                required
                onChange={(e) => {
                  setRecibido(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Recibidos</option>
                <option value="No">No Recibidos</option>
              </Input>
            </Col>
            <Col md={1}>
              <Label>Costeado</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCosteado}
                required
                onChange={(e) => {
                  setSelectedCosteado(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>
            <Col md={1}>
              <Label>Kasher</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedKasher}
                required
                onChange={(e) => {
                  setSelectedKasher(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Kasher">Kasher</option>
                <option value="Taref">Taref</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr
                      style={
                        a.recibido === "Si" && a.costeado === "Si"
                          ? { backgroundColor: "#64e379" } // Verde
                          : a.recibido === "Si" && a.costeado === "No"
                          ? { backgroundColor: "#e1a146ff" } // Amarillo
                          : a.recibido === "No" && a.costeado === "Si"
                          ? { backgroundColor: "#86c3f5" } // Azul
                          : {}
                      }
                    >
                      <td>{a.is_active}</td>
                      <td>{a.recibido}</td>
                      <td>{a.numero}</td>
                      <td>{a.fechaEmbarque}</td>
                      <td>{a.proveedor}</td>
                      <td>{a.contenedor}</td>
                      <td>{a.numeroInterno}</td>
                      <td>{a.kasher}</td>
                      <td>{a.costeado}</td>
                      <td>{a.fechaEstimada}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.totalCantidad)}
                      </td>
                      <td>
                        {user.embarques ? (
                          <div>
                            {user.menu_compras && a.validado == "No" ? (
                              <span>
                                <Button
                                  color="danger"
                                  // id="Baja"
                                  onClick={(e) => validar(a._id)}
                                  size="sm"
                                >
                                  <i class="fas fa-thumbs-up"></i>
                                </Button>
                              </span>
                            ) : (
                              <span>
                                <Button
                                  color="primary"
                                  // id="Baja"
                                  onClick={(e) => desvalidar(a._id)}
                                  size="sm"
                                >
                                  <i class="fas fa-thumbs-up"></i>
                                </Button>
                              </span>
                            )}
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                user.inventarios_costos
                                  ? PDFOCCostos(
                                      a.fechaEmbarque,
                                      a.contenedor,
                                      a.numeroInterno,
                                      a.fechaEstimada,
                                      a.creado,
                                      a._id,
                                      a.numero
                                    )
                                  : PDFOC(
                                      a.fechaEmbarque,
                                      a.contenedor,
                                      a.numeroInterno,
                                      a.fechaEstimada,
                                      a.creado,
                                      a._id,
                                      a.numero
                                    )
                              }
                            >
                              <i className="far fa-file-pdf"></i>
                            </Button>

                            <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaInfo(
                                  a.fechaEmbarque,
                                  a.fechaEstimada,
                                  a.numeroInterno,
                                  a.kasher,
                                  a.tipoCambioUSDMXN,
                                  a.observaciones,
                                  a.contenedor,
                                  a.idEmbarques,
                                  a.recibido,
                                  a._id
                                )
                              }
                            >
                              <i class="far fa-edit"></i>
                            </Button>
                            {/* {a.recibido == "No" ? ( */}
                            {/* <Button
                            color="info"
                            id="Editar"
                            size="sm"
                            onClick={(e) =>
                              EditArticulos(a._id, a.contenedor, a.idProveedor)
                            }
                          >
                            <i class="fas fa-cart-plus"></i>
                          </Button> */}
                            {/* ):undefined} */}

                            {user.inventarios_costos ? (
                              <>
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    EditArticulos(
                                      a._id,
                                      a.idProveedor,
                                      a.totalCantidad,
                                      a.total_costo,
                                      a.kasher,
                                      a.tipoCambioUSDMXN,
                                      a.total_gasto,
                                      a.costeado
                                    )
                                  }
                                >
                                  <i class="fas fa-cart-plus"></i>
                                </Button>
                                <Button
                                  color="primary"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    EditGastos(a._id, a.total_gasto)
                                  }
                                >
                                  <i class="fas fa-dollar-sign"></i>
                                </Button>
                                {/* {a.kasher == "Taref" ? (
                                  <Button
                                    color={
                                      a.costeado === "Si"
                                        ? "success"
                                        : "warning"
                                    }
                                    id="Editar"
                                    size="sm"
                                    onClick={(e) => costear(a._id)}
                                  >
                                    <i class="fas fa-calculator"></i>
                                  </Button>
                                ) : undefined} */}
                              </>
                            ) : undefined}
                          </div>
                        ) : (
                          <div>
                            <Button color="info" id="Editar" size="sm" disabled>
                              <i class="far fa-edit"></i>
                            </Button>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Embarque # {numeroEmbarque}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Fecha Embarque</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fechaEmbarque}
                required
                onChange={(e) => {
                  setFechaEmbarque(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label># Contenedor</Label>
              <Input
                type="text"
                placeholder="contenedor"
                value={contenedor}
                required
                onChange={(e) => {
                  setContenedor(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Numero Interno</Label>
              <Input
                type="text"
                placeholder="NumeroInterno"
                value={numeroInterno}
                required
                onChange={(e) => {
                  setNumeroInterno(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Kasher</Label>
              <Input
                type="select"
                value={kasher}
                required
                onChange={(e) => {
                  setKasher(e.target.value);
                }}
              >
                <option value="Taref">Taref</option>
                <option value="Kasher">Kasher</option>
              </Input>
            </Col>
            <Col md={4}>
              <Label>Fecha Estimada de Arribo</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fechaEstimada}
                required
                onChange={(e) => {
                  setFechaEstimada(e.target.value);
                }}
              />
            </Col>
            <Col md={4}>
              <Label>Tipo Cambio USD MXN</Label>
              <Input
                type="number"
                placeholder="Fecha"
                value={tipoCambioUSDMXN}
                required
                onChange={(e) => {
                  setTipoCambioUSDMXN(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Recibido</Label>
              <Input
                type="select"
                value={recibidoEdit}
                onChange={(e) => {
                  setRecibidoEdit(e.target.value);
                }}
              >
                <option value={"No"}>No</option>
                <option value={"Si"}>Si</option>
              </Input>
            </Col>
            <Col md={8}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editEmbarques}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios segundos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      {/* Modal editar Gastos */}

      <Modal size="xl" isOpen={modalEditGastos} toggle={toggleEditGastos}>
        <ModalHeader toggle={toggleEditGastos}>
          <h4>Editar Gastos Embarque</h4>
          <h4>Total: {gastosEmbarquesTotales}</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveGastosEmbarque}>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Concepto</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Proveedor</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Fecha</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Estimado</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Real</Label>
              </Col>
            </Row>
            {gastosEmbarque.map((ae) => (
              <div key={ae._id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="concepto"
                      type="select"
                      value={ae.conceptosGastosEmbarques[0]._id}
                      disabled
                    >
                      <option value="">Selecciona</option>
                      {conceptosGastos.map((a) => {
                        return <option value={a._id}>{a.concepto}</option>;
                      })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="proveedores"
                      type="select"
                      value={
                        typeof ae.proveedores === "string"
                          ? ae.proveedores
                          : ae.proveedores?.[0]?._id || ""
                      }
                      onChange={(event) =>
                        handleChangeInputGastosExistentes(ae._id, event)
                      }
                    >
                      <option value="">Selecciona</option>
                      {proveedores.map((p) => (
                        <option value={p._id}>
                          {p.codigo} {p.nombre_comercial}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="fecha"
                      type="date"
                      value={ae.fecha || ""}
                      onChange={(event) =>
                        handleChangeInputGastosExistentes(ae._id, event)
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="estimado"
                      type="number"
                      min="0"
                      step="any"
                      value={ae.estimado}
                      onChange={(event) =>
                        handleChangeInputGastosExistentes(ae._id, event)
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="real"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="real"
                      value={ae.real}
                      onChange={(event) =>
                        handleChangeInputGastosExistentes(ae._id, event)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

            {/* Agregar articulos */}
            {inputFieldsGastos.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="concepto"
                      type="select"
                      value={inputField.concepto}
                      onChange={(event) => BuscaGasto(inputField.id, event)}
                    >
                      <option value="">Selecciona</option>
                      {conceptosGastos.map((a) => {
                        return <option value={a._id}>{a.concepto}</option>;
                      })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="proveedores"
                      type="select"
                      value={inputField.proveedores}
                      onChange={(event) =>
                        handleChangeInputGastos(inputField.id, event)
                      }
                    >
                      <option value="">Selecciona</option>
                      {proveedores.map((p) => (
                        <option value={p._id}>
                          {p.codigo} {p.nombre_comercial}
                        </option>
                      ))}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="fecha"
                      type="date"
                      value={inputField.fecha}
                      onChange={(event) =>
                        handleChangeInputGastos(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="estimado"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.estimado}
                      onChange={(event) =>
                        handleChangeInputGastos(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="real"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="real"
                      value={inputField.real}
                      onChange={(event) =>
                        handleChangeInputGastos(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={12} className="text-right mt-1">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={setInputFieldsGastos.length === 1}
                      onClick={() => handleRemoveFieldsGastos(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFieldsGastos}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

<Modal size="xxl" isOpen={modalEditFOB} toggle={toggleEditFOB}>
  <ModalHeader toggle={toggleEditFOB}>
    <h4>Precosteo Taref</h4>
    <h6>
            Total Gastos:
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(totalGastoPrecosteo)}
          </h6>
          <h6>
            TC: ${tipoCambio}
          </h6>
  </ModalHeader>
  <ModalBody>
    {/* aquí usamos el flag costear = false en el submit normal */}
    <Form onSubmit={(e) => saveFOBEmbarque(e, false)}>
      <Table bordered size="sm" responsive>
        <thead className="text-center">
          <tr>
            <th>Artículo</th>
            <th>Cantidad</th>
            <th>FOB</th>
            <th>CBM</th>
            <th>Comisión %</th>
            <th>Comisión $</th>
            <th>Total Pesos</th>
            <th>Gastos</th>
            <th>Costo Unitario</th>
          </tr>
        </thead>

        <tbody>
          {articulosPedido.map((ae, index) => {
            const costoUSDFOB = Number(ae.costoUSD) || 0;
            const comision = Number(ae.comisionVendedorCantidad) || 0;
            const gastos = Number(ae.gastos) || 0;

            const cantidad = Number(ae.cantidad) || 0;
                  const costoUSDTotal = ae.costoUSD + ae.comisionVendedorCantidad;
                  const cbm = Number(ae.CBM) || 0;

                  // ===== Fórmulas =====
                  const total = cantidad * costoUSDTotal;
                  // TC por artículo (anticipos/pagos) con respaldo al del embarque
                  const tcAe = Number(ae.tipoCambioUSDMXN) > 0
                    ? Number(ae.tipoCambioUSDMXN)
                    : (Number(tipoCambio) || 0);
                  const costoPesos = costoUSDTotal * tcAe;
                  const costoUnitario =costoPesos + gastos;

            return (
              <tr key={ae.id || ae._id}>
                {/* Artículo */}
                <td>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={ae.articulo}
                    disabled
                  />
                </td>

                {/* Cantidad */}
                <td>
                  <Input
                    bsSize="sm"
                    type="number"
                    value={ae.cantidad}
                    disabled
                  />
                </td>

                {/* FOB */}
                <td>
                  <Input
                    bsSize="sm"
                    name="costoUSD"
                    type="number"
                    value={ae.costoUSD}
                    onChange={(e) =>
                      handleCostoChange(index, e.target.value)
                    }
                  />
                </td>

                {/* CBM */}
                <td>
                  <Input
                    bsSize="sm"
                    name="CBM"
                    type="number"
                    value={ae.CBM}
                    onChange={(e) =>
                      handleCBMChange(index, e.target.value)
                    }
                  />
                </td>

                {/* Comisión % */}
                <td>
                  <Input
                    bsSize="sm"
                    name="comisionVendedorPorcentaje"
                    type="number"
                    value={ae.comisionVendedorPorcentaje}
                    onChange={(e) =>
                      handleComisionChange(index, e.target.value)
                    }
                  />
                </td>

                {/* Comisión $ */}
                <td>
                  <Input
                    bsSize="sm"
                    name="comisionVendedorCantidad"
                    type="number"
                    value={comision.toFixed(2)}
                    disabled
                  />
                </td>

                {/* Total Pesos */}
                <td>
                  <Input
                    bsSize="sm"
                    name="totalPesos"
                    type="number"
                    value={((Number(comision) + Number(ae.costoUSD)) * tcAe).toFixed(2)}
                    disabled
                  />
                </td>

                {/* Gastos (solo lectura) */}
                <td>
                  <Input
                    bsSize="sm"
                    name="gastos"
                    type="number"
                    value={gastos.toFixed(2)}
                    disabled
                  />
                </td>

                {/* Costo Unitario */}
                <td>
                  <Input
                    bsSize="sm"
                    name="costoUnitario"
                    type="number"
                    value={costoUnitario.toFixed(2)}
                    disabled
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      {/* Botones */}
      {validaBoton ? (
              costeadoEdit === "No" ? (
                <>
                  {/* Guardar normal (solo precosteo) */}
                  <Button type="submit" className="btn btn-success">
                    Guardar
                  </Button>

                  {/* Guardar y costear */}
                  <Button
                    type="button"
                    className="btn btn-warning ms-2"
                    onClick={(e) => saveFOBEmbarque(e, true)}
                  >
                    Guardar y Costear
                  </Button>
                </>
              ) : (
                <>
                  {/* Guardar normal deshabilitado si ya está costeado */}
                  <Button type="submit" className="btn btn-success" disabled>
                    Guardar
                  </Button>

                  {/* Guardar y costear sigue activo */}
                  <Button
                    type="button"
                    className="btn btn-warning ms-2"
                    onClick={(e) => saveFOBEmbarque(e, true)}
                  >
                    Guardar y Costear
                  </Button>
                </>
              )
            ) : (
              <>
                <Button type="submit" className="btn btn-success" disabled>
                  Guardar
                </Button>
                <Button type="button" className="btn btn-warning ms-2" disabled>
                  Guardar y Costear
                </Button>
              </>
            )}
    </Form>
  </ModalBody>
</Modal>


      <Modal
        size="xxl"
        isOpen={modalEditFOBKasher}
        toggle={toggleEditFOBKasher}
      >
        <ModalHeader toggle={toggleEditFOBKasher}>
          <h4>Precosteo Kasher</h4>
          <h6>
            Total Gastos{" "}
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(totalGastoPrecosteo)}
          </h6>
           <h6>
            TC: ${tipoCambio}
          </h6>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={(e) => saveFOBEmbarque(e, false)}>
            <Table bordered size="sm" responsive>
              <thead className="text-center">
                <tr>
                  <th>Artículo</th>
                  <th>Cantidad</th>
                  <th>FOB</th>
                  <th>Costo Factura</th>
                  <th>CBM Total</th>
                  <th>Comisión %</th>
                  <th>Comisión $</th>
                  <th>Total</th>
                  <th>Dec. Pesos</th>
                  <th>DTA</th>
                  <th>IGI %</th> {/* 👈 NUEVA COLUMNA */}
                  <th>IGI</th>
                  <th>IVA</th>
                  <th>Impuestos</th>
                  <th>Costo Pesos</th>
                  <th>Gastos</th>
                  <th>Costo Unitario</th>
                </tr>
              </thead>

              <tbody>
                {articulosPedido.map((ae, index) => {
                  const cantidad = Number(ae.cantidad) || 0;
                  // const costoUSD = Number(ae.costoUSD) || 0;
                  const costoFactura =
                    Number(ae.costoFactura ?? ae.costoUSD) || 0;
                  const cbm = Number(ae.CBM) || 0;
                  const gastos = Number(ae.gastos) || 0;
                  const igiPorcentaje = ae.igiPorcentaje ?? 15; // 👈 default 15%
            const comision = Number(ae.comisionVendedorCantidad) || 0;
                  const costoUSD = ae.costoUSD + ae.comisionVendedorCantidad;

                  // ===== Fórmulas =====
                  const total = cantidad * costoFactura;
                  const declaradoPesos = costoFactura * tipoCambio;
                  const dta = declaradoPesos * 0.008;
                  const igi = declaradoPesos * (Number(igiPorcentaje) / 100); // 👈 aquí usamos el %
                  const baseIVA = declaradoPesos + dta + igi;
                  const iva = baseIVA * 0.16;
                  const impuestos = dta + igi + iva;
                  const costoPesos = costoUSD * tipoCambio;
                  const costoUnitario = impuestos + costoPesos + gastos;

                  return (
                    <tr key={ae.id || ae._id}>
                      {/* Articulo */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="text"
                          disabled
                          value={ae.articulo}
                        />
                      </td>

                      {/* Cantidad */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={cantidad}
                        />
                      </td>

                      {/* FOB */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          value={costoUSD}
                          onChange={(e) =>
                            handleCostoChange(index, e.target.value)
                          }
                        />
                      </td>

                      {/* Costo Factura */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          value={costoFactura}
                          onChange={(e) =>
                            handleCostoFacturaChange(index, e.target.value)
                          }
                        />
                      </td>

                      {/* CBM */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          value={cbm}
                          onChange={(e) =>
                            handleCBMChange(index, e.target.value)
                          }
                        />
                      </td>
 {/* Comisión % */}
                        <td>
                  <Input
                    bsSize="sm"
                    name="comisionVendedorPorcentaje"
                    type="number"
                    value={ae.comisionVendedorPorcentaje}
                    onChange={(e) =>
                      handleComisionChange(index, e.target.value)
                    }
                  />
                </td>

                {/* Comisión $ */}
                <td>
                  <Input
                    bsSize="sm"
                    name="comisionVendedorCantidad"
                    type="number"
                    value={comision.toFixed(2)}
                    disabled
                  />
                </td>

                      {/* Total */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={total.toFixed(2)}
                        />
                      </td>

                      {/* Declarado en pesos */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={declaradoPesos.toFixed(2)}
                        />
                      </td>

                      {/* DTA */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={dta.toFixed(2)}
                        />
                      </td>

                      {/* IGI % (editable) */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          value={igiPorcentaje}
                          onChange={(e) =>
                            handleIgiChange(index, e.target.value)
                          }
                        />
                      </td>

                      {/* IGI (monto) */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={igi.toFixed(2)}
                        />
                      </td>

                      {/* IVA */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={iva.toFixed(2)}
                        />
                      </td>

                      {/* Impuestos */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={impuestos.toFixed(2)}
                        />
                      </td>

                      {/* Costo Pesos */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={costoPesos.toFixed(2)}
                        />
                      </td>

                      {/* Gastos */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          value={gastos}
                          disabled
                        />
                      </td>

                      {/* Costo Unitario */}
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          disabled
                          value={costoUnitario.toFixed(2)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            {validaBoton ? (
              costeadoEdit === "No" ? (
                <>
                  {/* Guardar normal (solo precosteo) */}
                  <Button type="submit" className="btn btn-success">
                    Guardar
                  </Button>

                  {/* Guardar y costear */}
                  <Button
                    type="button"
                    className="btn btn-warning ms-2"
                    onClick={(e) => saveFOBEmbarque(e, true)}
                  >
                    Guardar y Costear
                  </Button>
                </>
              ) : (
                <>
                  {/* Guardar normal deshabilitado si ya está costeado */}
                  <Button type="submit" className="btn btn-success" disabled>
                    Guardar
                  </Button>

                  {/* Guardar y costear sigue activo */}
                  <Button
                    type="button"
                    className="btn btn-warning ms-2"
                    onClick={(e) => saveFOBEmbarque(e, true)}
                  >
                    Guardar y Costear
                  </Button>
                </>
              )
            ) : (
              <>
                <Button type="submit" className="btn btn-success" disabled>
                  Guardar
                </Button>
                <Button type="button" className="btn btn-warning ms-2" disabled>
                  Guardar y Costear
                </Button>
              </>
            )}
          </Form>
        </ModalBody>
      </Modal>
      {loader}
    </>
  );
}

export default ListadoEmbarques;


            {/* Agregar Articulos */}
            {/* <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Pend Embarcar</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">FOB</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">CBM</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Comision %</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Comision $</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>
            {inputFieldsNuevos.map((inputField, index) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.articulosOrden}
                      // required
                      onChange={(event) => {
                        BuscaArticulo(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosOC
                        .filter(
                          (a) =>
                            a.articulos?.[0]?.proveedores?.[0]?._id ===
                            idProveedorEdit
                        )
                        .sort((a, b) =>
                          a.articulos[0].SKU > b.articulos[0].SKU ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.articulos[0].SKU}</option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="pendEmbarcar"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.pendEmbarcar}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="costo"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Costo"
                      value={inputField.costo}
                      onChange={(event) =>
                        handleChangeInputCosto(event, inputField.id)
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      onChange={(event) =>
                        handleChangeInputCantidadNuevos(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="CBM"
                      type="number"
                      value={inputField.CBM}
                      onChange={(e) =>
                        handleCBMChangeNuevos(index, e.target.value)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="comisionVendedorPorcentaje"
                      type="number"
                      value={inputField.comisionVendedorPorcentaje}
                      onChange={(e) =>
                        handleComisionChangeNuevos(index, e.target.value)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="comisionVendedorCantidad"
                      type="number"
                      value={inputField.comisionVendedorCantidad.toFixed(2)}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="comisionVendedorCantidad"
                      type="number"
                      value={(
                        inputField.comisionVendedorCantidad +
                        inputField.costoUSD
                      ).toFixed(2)}
                      disabled
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))} */}